import { DateInput, SelectInput, TextInput } from "react-admin";
import ReceiptFilterLiveForm, {
  receiptFilterCompactInputProps,
  receiptFilterDateFieldSx,
} from "@/components/receipt-filters/ReceiptFilterLiveForm";
import { LAGAT_RECEIPT_FILTER_FIELDS } from "./lagat-receipt-filter-fields";
import { PAYMENT_MODE_OPTIONS } from "./lagat-receipt-utils";

const [paymentModeField, searchField, startDateField, endDateField] = LAGAT_RECEIPT_FILTER_FIELDS;

export default function LagatReceiptFilterBar() {
  return (
    <ReceiptFilterLiveForm>
      <SelectInput
        source={paymentModeField.source}
        label={paymentModeField.label}
        choices={PAYMENT_MODE_OPTIONS}
        {...receiptFilterCompactInputProps}
        sx={{ minWidth: { sm: 140 } }}
      />
      <TextInput
        source={searchField.source}
        label={searchField.label}
        resettable
        {...receiptFilterCompactInputProps}
        sx={{ minWidth: { sm: 200 }, flex: { sm: "1 1 200px" }, maxWidth: { sm: 360 } }}
      />
      <DateInput
        source={startDateField.source}
        label={startDateField.label}
        {...receiptFilterCompactInputProps}
        sx={receiptFilterDateFieldSx}
      />
      <DateInput
        source={endDateField.source}
        label={endDateField.label}
        {...receiptFilterCompactInputProps}
        sx={receiptFilterDateFieldSx}
      />
    </ReceiptFilterLiveForm>
  );
}
